export default __webpack_public_path__ + "static/media/logo 1.ebc03fee.png";